export const adminTheme = {
  color: {
    pageBg: "#f8fafc",
    surface: "#ffffff",
    surfaceMuted: "#f8fafc",
    border: "#e5e7eb",
    borderStrong: "#dbe3ee",

    text: "#0f172a",
    textSoft: "#475569",
    textMuted: "#64748b",
    textFaint: "#94a3b8",

    primaryBg: "#ecfeff",
    primaryText: "#155e75",
    primaryBorder: "#bae6fd",

    accentBg: "#eef2ff",
    accentText: "#4338ca",
    accentBorder: "#c7d2fe",

    successBg: "#ecfdf5",
    successText: "#166534",
    successBorder: "#bbf7d0",

    warningBg: "#fff7ed",
    warningText: "#9a3412",
    warningBorder: "#fed7aa",

    errorBg: "#fef2f2",
    errorText: "#b91c1c",
    errorBorder: "#fecaca",

    // Backward-compatible aliases
    textPrimary: "#0f172a",
    textSecondary: "#64748b",
    textTertiary: "#94a3b8",

    background: "#f8fafc",
    card: "#ffffff",
    cardMuted: "#f8fafc",

    primary: "#155e75",
    secondary: "#64748b",
    muted: "#94a3b8",

    success: "#166534",
    warning: "#9a3412",
    error: "#b91c1c",
    danger: "#b91c1c",

    link: "#155e75",
  },

  radius: {
    sm: "12px",
    md: "16px",
    lg: "18px",
    pill: "999px",
  },

  shadow: {
    sm: "0 8px 24px rgba(15, 23, 42, 0.04)",
    md: "0 14px 32px rgba(15, 23, 42, 0.08)",
    error: "0 8px 24px rgba(127, 29, 29, 0.04)",
  },

  space: {
    xs: "8px",
    sm: "10px",
    md: "12px",
    lg: "16px",
    xl: "18px",
    xxl: "20px",
    section: "24px",
  },

  type: {
    titleLg: "clamp(1.75rem, 1.3rem + 1.2vw, 2.3rem)",
    titleMd: "1.2rem",
    titleSm: "1rem",
    body: "0.95rem",
    bodyLg: "0.98rem",
    label: "0.9rem",
    eyebrow: "0.78rem",
    pill: "0.8rem",
  },

  transition: {
    base: "all 180ms ease",
  },
} as const;

export type AdminTheme = typeof adminTheme;